import React from "react";
import { formatWalletAmount } from "./payouts-mock-data";

export function PayoutHistoryRow({ row }) {
  return (
    <article className="overflow-hidden border-b border-[#F3F4F6] py-3 last:border-0 sm:py-3.5">
      <div className="grid grid-cols-[minmax(0,34%)_minmax(0,1fr)_auto] items-center gap-x-1.5 text-[11px] leading-tight sm:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] sm:gap-x-2 sm:text-[13px]">
        <span className="min-w-0 truncate font-medium text-[#4B5563]">
          {row.dateLabel}
        </span>
        <span
          className="min-w-0 truncate font-semibold text-[#1F2937]"
          title={row.reference}
        >
          {row.reference}
        </span>
        <span className="shrink-0 pl-1 text-right font-semibold tabular-nums text-[#1F2937]">
          {formatWalletAmount(row.amountCents)}
        </span>
      </div>
      <p
        className="my-0 mt-1 truncate text-[10px] leading-snug text-[#9CA3AF] sm:mt-1.5 sm:text-[12px]"
        title={row.methodLabel}
      >
        {row.methodLabel}
      </p>
    </article>
  );
}
